module.exports = __webpack_public_path__ + "img/crm_resale.4c15b180.png";